import { render, staticRenderFns } from "./Boleto.vue?vue&type=template&id=c91fe218&scoped=true"
import script from "./Boleto.vue?vue&type=script&lang=js"
export * from "./Boleto.vue?vue&type=script&lang=js"
import style0 from "./Boleto.vue?vue&type=style&index=0&id=c91fe218&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91fe218",
  null
  
)

export default component.exports